
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Notifications() {
  const navigate = useNavigate();
  const [notifications] = useState([
    {
      id: 1,
      type: 'message',
      title: 'رسالة جديدة من سارة أحمد',
      message: 'مرحباً! هل أنت في نفس الرحلة SV123؟',
      time: 'منذ 5 دقائق',
      unread: true,
      avatar: 'https://public.readdy.ai/ai/img_res/2aa59cb1a25538098db7e9d11f5b680d.jpg'
    },
    {
      id: 2,
      type: 'flight',
      title: 'تحديث الرحلة SV123',
      message: 'تم تأكيد موعد الإقلاع الساعة 14:30',
      time: 'منذ 30 دقيقة',
      unread: true,
      icon: 'ri-flight-takeoff-line'
    },
    {
      id: 3,
      type: 'passenger',
      title: 'راكب جديد انضم للرحلة',
      message: 'انضم محمد علي إلى قائمة ركاب الرحلة MS456',
      time: 'منذ ساعة',
      unread: false,
      icon: 'ri-user-add-line'
    },
    {
      id: 4,
      type: 'system',
      title: 'تحديث التطبيق',
      message: 'يتوفر إصدار جديد من التطبيق يحتوي على ميزات محسنة',
      time: 'منذ 3 ساعات',
      unread: false,
      icon: 'ri-download-line'
    },
    {
      id: 5,
      type: 'message',
      title: 'رسالة من أحمد محمد',
      message: 'هل تريد مشاركة التاكسي من المطار؟',
      time: 'أمس',
      unread: false,
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20middle%20eastern%20man%20in%20business%20attire%2C%20friendly%20smile%2C%20realistic%20portrait%20photography%2C%20modern%20office%20background%2C%20natural%20lighting&width=60&height=60&seq=2&orientation=squarish'
    }
  ]);

  const unreadCount = notifications.filter(n => n.unread).length;

  const getNotificationIcon = (notification: any) => {
    if (notification.avatar) {
      return (
        <img 
          src={notification.avatar} 
          alt="Avatar" 
          className="w-10 h-10 rounded-full object-cover"
        />
      );
    }
    
    const iconColors = {
      flight: 'bg-blue-100 text-blue-600',
      passenger: 'bg-green-100 text-green-600',
      system: 'bg-purple-100 text-purple-600',
      message: 'bg-orange-100 text-orange-600'
    };
    
    return (
      <div className={`w-10 h-10 rounded-full flex items-center justify-center ${iconColors[notification.type as keyof typeof iconColors]}`}>
        <i className={`${notification.icon} text-lg`}></i>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 pt-12 pb-4 px-6">
        <div className="flex items-center justify-between">
          <button 
            onClick={() => navigate('/main')}
            className="w-10 h-10 flex items-center justify-center"
          >
            <i className="ri-arrow-right-line text-xl text-gray-600"></i>
          </button>
          
          <div className="text-center">
            <h1 className="text-lg font-bold text-gray-800 font-arabic">الإشعارات</h1>
            {unreadCount > 0 && (
              <span className="text-sm text-blue-600 font-arabic">{unreadCount} إشعارات جديدة</span>
            )}
          </div>
          
          <button className="w-10 h-10 flex items-center justify-center">
            <i className="ri-settings-line text-xl text-gray-600"></i>
          </button>
        </div>
      </div>

      {/* Notifications List */}
      <div className="px-6 py-4">
        <div className="space-y-3">
          {notifications.map((notification) => (
            <div
              key={notification.id}
              className={`bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300 ${
                notification.unread ? 'border-r-4 border-blue-500' : ''
              }`}
            >
              <div className="flex items-start space-x-3 space-x-reverse">
                {getNotificationIcon(notification)}
                
                <div className="flex-1">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <h3 className={`text-sm font-arabic ${
                        notification.unread ? 'font-bold text-gray-800' : 'font-medium text-gray-700'
                      }`}>
                        {notification.title}
                      </h3>
                      <p className="text-gray-600 text-sm mt-1 font-arabic leading-relaxed">
                        {notification.message}
                      </p>
                    </div>
                    
                    {notification.unread && (
                      <div className="w-2 h-2 bg-blue-500 rounded-full ml-2"></div>
                    )}
                  </div>
                  
                  <div className="flex items-center justify-between mt-3">
                    <span className="text-xs text-gray-500 font-arabic">{notification.time}</span>
                    
                    {notification.type === 'message' && (
                      <button className="text-blue-600 text-sm font-arabic hover:text-blue-700">
                        رد
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Load More */}
        <div className="text-center mt-6 mb-20">
          <button className="text-blue-600 font-arabic hover:text-blue-700">
            تحميل المزيد من الإشعارات
          </button>
        </div>
      </div>

      <style jsx>{`
        .font-arabic {
          font-family: 'Tajawal', 'Noto Sans Arabic', sans-serif;
        }
      `}</style>
    </div>
  );
}